var map = {
	"./como_lo_hacemos.png": "9265",
	"./computador.png": "6b90",
	"./contacto.png": "ef84",
	"./correo.png": "f1fb",
	"./direccion.png": "1f12",
	"./donaciones.png": "bfad",
	"./facebook.png": "46b3",
	"./instagram.png": "c56a",
	"./logo_fundacion_pcshek.png": "dcf6",
	"./museo.png": "6949",
	"./nosotros.png": "f618",
	"./proyectos.png": "0bd4",
	"./telefono.png": "a8f2",
	"./twitter.png": "4ae6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc3e";